export default [
    {
        path: '/fo/purchase',
        name: '구매',
        component: () => import('@/page/purchase/Purchase.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '구매',
        }
    },
    {
        path: '/fo/purchase/deliveryAddress',
        name: '배송지 등록',
        component: () => import('@/page/purchase/DeliveryAddress.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '배송지 등록',
        }
    },
    {
        path: '/fo/purchase/daumkakaoAddress',
        name: '카카오 주소 검색',
        component: () => import('@/page/purchase/DaumKakaoAddress.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '카카오 주소 검색',
        }
    },
    {
        path: '/fo/purchase/complete',
        name: '결제 완료',
        component: () => import('@/page/purchase/PurchaseComplete.vue'),
    },
    {
        path: '/fo/purchase/history',
        name: '구매내역',
        component: () => import('@/page/purchase/PurchaseHistory.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '구매내역',
        }
    },
    {
        path: '/fo/purchase/cancel',
        name: '구매취소',
        component: () => import('@/page/purchase/PurchaseCancel.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '구매취소',
        }
    },
    {
        path: '/fo/purchase/refund',
        name: '환불',
        component: () => import('@/page/purchase/Refund.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '환불',
        }
    },
    {
        path: '/fo/purchase/detail',
        name: '구매 상세',
        component: () => import('@/page/purchase/PurchaseDetails.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '구매 상세',
        }
    },
    {
        path: '/fo/purchase/cancelInfo',
        name: '구매 취소 정보',
        component: () => import('@/page/purchase/PurchaseCancelInfo.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '구매 취소 정보',
        }
    },
    {
        path: '/fo/purchase/myCoupon',
        name: '내 쿠폰',
        component: () => import('@/page/purchase/MyCoupon.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '내 쿠폰',
        }
    },
    {
        path: '/fo/purchase/complete/cancel',
        name: '구매 결제 취소',
        component: () => import('@/page/purchase/PurchaseCompleteCancel.vue'),
        meta:{
            isHideHeader: false,
            isHideBack: false,
            headerTitle: '구매 결제 취소',
        }
    }
]